<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-21 08:34:10
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-22 17:20:07
 * @Description: 
-->
<template>
  <banner />
  <about />
  <section-history />
  <section-cta />
</template>

<script setup lang="ts">
  import Banner from './components/banner.vue'
  import About from './components/about.vue'

  useSeoMeta({
    title: '关于绘家 - 绘家科技',
    description:
      '了解绘家科技的发展历程与企业愿景。我们专注通过科技赋能物业，构建美好的智慧社区生活。',
    keywords: '绘家科技简介,企业文化,发展历程,智慧社区愿景',
    ogTitle: '关于绘家 - 绘家科技',
    ogDescription:
      '了解绘家科技的发展历程与企业愿景。我们专注通过科技赋能物业，构建美好的智慧社区生活。',
    ogImage: '/logo.png',
  })
</script>
